app = angular.module("seismology")

app.controller "TranscriptionCtrl", ($scope, $state, $stateParams, $mdDialog, $mdSidenav, $window, $interval, $mdToast, $firebaseAuth, $location, $mdPanel, Users, UserFavs, book, transcriptionList, currentAuth, Notification, CurrentUser) ->
  $scope.logout = ->
    $firebaseAuth().$signOut()
    $state.go('signin')
  $scope.goBack = ->
    ref = $stateParams.ref
    path = if ref then decodeURIComponent(ref) else  '/dashboard'
    $location.path(path)
  $scope.moment = $window.moment
  $scope.auth = currentAuth
  $scope.book = book
  $window.book = book
  $scope.id = book.$id
  $scope.transcriptions = transcriptionList
  $scope.users = Users    
  $scope.textEdit = ""
  $scope.currentUser = CurrentUser.get()
  $scope.toggleFav = ->
    $scope.fav.toggle()
  $scope.fav = UserFavs.getFav(book.$id)
  $scope.notifications = Notification.getList()
  $scope.showNotifications = ->
    position = $mdPanel.newPanelPosition()
      .relativeTo('.notification-btn')
      .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW)
    config =
      attachTo: angular.element(document.body)
      controller: 'NotificationPanelCtrl'
      templateUrl: 'templates/partial/panel-notification.html'
      panelClass: 'notification-panel'
      position: position
      clickOutsideToClose: true
      escapeToClose: true
      focusOnOpen: false
      zIndex: 9999999
    $mdPanel.open(config).then (panel) ->
      $window.panel = panel
  


  $scope.book.$loaded ->
    tyleSources = for img in $scope.book.dzi
      'https://honkoku.org/dzi/'+img
    $scope.viewer = OpenSeadragon
      id: 'openseadragon-viewer'
      tileSources: tyleSources
      sequenceMode: true
      showNavigator:  false
      navigatorPosition: "BOTTOM_LEFT"
      defaultZoomLevel: 1
      showNavigationControl: true
      showFullPageControl: false
      showSequenceControl: false
      springStiffness: 18
      crossOriginPolicy: false
      zoomPerScroll: 1.1
    $window.viewer = $scope.viewer
    $window.anno.makeAnnotatable($scope.viewer)

  # user messages
  $scope.toastMessageQueue = []
  showMessageInQueue = ->
    return unless $scope.toastMessageQueue.length > 0
    msgKey = $scope.toastMessageQueue.shift()
    return if $mdSidenav("left").isOpen()
    msg = $scope.messages.$getRecord(msgKey)
    $mdToast.show
      hideDelay   : 3000
      position    : 'bottom right'
      templateUrl : 'templates/transcription/message-toast.html'
      controller  : ($mdToast, $scope, Users)->
        $scope.msg = msg
        $scope.users = Users
  $interval(showMessageInQueue, 3000)


app.controller "TranscriptionEditorCtrl", ($scope, transcription, $state, $sce) ->
  $scope.transcription = transcription
  $scope.$parent.childState = $state.$current.name.split(".").reverse()[0]
  console.log "editor", $state.$current.name.split(".").reverse()[0]
  $scope.viewHtml = $sce.trustAsHtml($scope.transcription.getFormattedHtml())
  transcription.$watch ->
    $scope.viewHtml = $sce.trustAsHtml($scope.transcription.getFormattedHtml())

app.controller "TranscriptionInputCtrl", ($scope, $window, $state, $sce, $interval, transcription) ->
  $window.transcription = transcription
  $scope.transcription = transcription
  $scope.showActionButtons = false
  $scope.toggleActionButtons = ->
    $scope.showActionButtons = !$scope.showActionButtons

  transcription.$loaded ->
    console.log 'editing'
    if transcription.isEditingByCurrentUser() 
      update = ->
        if transcription.tempChanged        
          console.log 'save temp'
          transcription.$save().then ->
            transcription.setTempChanged(false)
      $interval(update, 3000)

  $scope.handleChange = ->
    # 下書きに対する変更
    $scope.transcription.tempChanged = true
      
  $scope.insertRuby = ($event)->
    $event.stopImmediatePropagation()    
    sel = $window.getSelection()
    text = sel.toString()
    repl = ""
    if text and text.length > 0
      repl = "《ルビ：#{text}｜ここにルビを入力》"
    else
      repl = "《ルビ：漢字｜ここにルビを入力》"
    if sel.rangeCount
      range = sel.getRangeAt(0)
      range.deleteContents()
      node = $window.document.createTextNode(repl)
      range.insertNode(node)
      range2 = $window.document.createRange()
      range2.setStart(node, 4)
      range2.setEnd(node, 6)
      sel.removeAllRanges()
      sel.addRange(range2)

  $scope.insertOdoriji = ($event)->
    $event.stopImmediatePropagation()
    list = [ 'ゝ','ゞ', 'ヽ','ヾ', '〻', '々', '〳〵', '〴〵']
    sel = $window.getSelection()
    return if sel.rangeCount is 0
    current = sel.toString()
    index = list.indexOf(current)      
    if index >= 0
      sel.deleteFromDocument()
      index = index - list.length if index >= list.length-1
      repl = list[index+1]
    else
      repl = list[0]
    node = $window.document.createTextNode(repl)
    range = sel.getRangeAt(0)
    range.insertNode(node)
    
    range2 = $window.document.createRange()      
    range2.setStart(node, 0)
    range2.setEnd(node, repl.length)
    sel.removeAllRanges()
    sel.addRange(range2)


  $scope.insertFreq = ($event)->
    $event.stopImmediatePropagation()
    list = ['□', 'ゟ','ゐ','ヰ', 'ゑ', 'ヱ']
    sel = $window.getSelection()
    return if sel.rangeCount is 0
    current = sel.toString()
    index = list.indexOf(current)      
    if index >= 0
      sel.deleteFromDocument()
      index = index - list.length if index >= list.length-1
      repl = list[index+1]
    else
      repl = list[0]
    node = $window.document.createTextNode(repl)
    range = sel.getRangeAt(0)
    range.insertNode(node)
    
    range2 = $window.document.createRange()      
    range2.setStart(node, 0)
    range2.setEnd(node, repl.length)
    sel.removeAllRanges()
    sel.addRange(range2)

      
  $scope.insertNote = ($event)->
    $event.stopImmediatePropagation()
    sel = $window.getSelection()
    text = sel.toString()
    repl = "【ここに注記を入力】"
    if sel.rangeCount
      range = sel.getRangeAt(0)
      range.deleteContents()
      node = $window.document.createTextNode(repl)
      range.insertNode(node)
      range2 = $window.document.createRange()
      range2.setStart(node, repl.length-9)
      range2.setEnd(node, repl.length-1)
      sel.removeAllRanges()
      sel.addRange(range2)
        
  
  $scope.insertWarigaki = ($event)->
    sel = $window.getSelection()
    repl = "《割書：一行目｜二行目》"
    if sel.rangeCount
      range = sel.getRangeAt(0)
      range.deleteContents()
      node = $window.document.createTextNode(repl)
      range.insertNode(node)
      range2 = $window.document.createRange()
      range2.setStart(node, repl.length-8)
      range2.setEnd(node, repl.length-5)
      sel.removeAllRanges()
      sel.addRange(range2)

  $scope.insertHako = ($event)->
    $event.stopImmediatePropagation()
    sel = $window.getSelection()
    text = sel.toString()
    repl = ""
    hasSelection = text and text.length
    if hasSelection
      repl = "《箱：#{text}》"
    else
      repl = "《箱：》"
    if sel.rangeCount
      range = sel.getRangeAt(0)
      range.deleteContents()
      node = $window.document.createTextNode(repl)
      range.insertNode(node)
      range2 = $window.document.createRange()
      range2.setStart(node, repl.length-1)
      range2.setEnd(node, repl.length-1)
      sel.removeAllRanges()
      sel.addRange(range2)

  $scope.insertKunten = ($event)->
    $event.stopImmediatePropagation()
    okuri = '［オクリ］'
    kaeri = '｛カエリ｝'
    list = [okuri, kaeri]
    sel = $window.getSelection()
    return if sel.rangeCount is 0
    current = sel.toString()
    if current is okuri
      sel.deleteFromDocument()
      repl = kaeri
    else if current is kaeri
      sel.deleteFromDocument()
      repl = okuri
    else
      repl = okuri
    node = $window.document.createTextNode(repl)
    range = sel.getRangeAt(0)
    range.insertNode(node)
    
    range2 = $window.document.createRange()
    range2.setStart(node, 0)
    range2.setEnd(node, repl.length)
    sel.removeAllRanges()
    sel.addRange(range2)



app.controller "TranscriptionNotesCtrl", ($scope, $mdDialog, $window, transcription) ->
  transcription.$loaded ->
    $scope.notes = transcription.getNoteArray()
  
  $scope.addNote = (ev) ->
    console.log "notes"
    prompt = $mdDialog.prompt()
      .title('ノートを追加')
      .textContent('内容を入力してください')
      .placeholder('ここに内容を入力')
      .targetEvent(ev)
      .ok('追加')
      .cancel('キャンセル')
    $mdDialog.show(prompt).then (input) ->
      transcription.addNote(input).$save()

app.controller "TranscriptionHistoryCtrl", ($scope, $mdDialog, transcription, Timeline, Diff) ->
  transcription.$loaded ->
    code = transcription.getCode()
    $scope.timeline = Timeline.getListByCode(code)
    $scope.showDiff = (id, ev) ->
      selected = $scope.timeline.$getRecord(id)
      diffHtml = Diff.styledDiffHtml(selected.previousText, selected.text)
      $mdDialog.show
        templateUrl: 'templates/transcription/diff_dialog.html'
        parent: angular.element(document.body)
        targetEvent: ev,
        clickOutsideToClose: true
        controller: ($scope, $mdDialog, $sce, $window) ->
          $scope.moment = $window.moment
          $scope.event = selected
          $scope.diffHtml = $sce.trustAsHtml(diffHtml)
          $scope.close = ->
            $mdDialog.hide()
      


app.controller "TranscriptionActionButtonsCtrl", ($scope, $mdDialog, $mdToast, $state, $window, Timeline, Users, Books, transcription, CurrentUser) ->
  transcription.$loaded ->
    $scope.transcription = transcription
  
  $scope.startTranscribing = (ev)->
    $mdDialog.show
      templateUrl: 'templates/transcription/starting_dialog.html'
      parent: angular.element(document.body)
      targetEvent: ev,
      clickOutsideToClose:true
      controller: ($scope, $mdDialog) ->
        $scope.realtimeMode = false
        $scope.transcription = transcription
        $scope.cancel = ->
          $mdDialog.hide()
        $scope.start = ->
          $scope.transcription.startEditing($scope.realtimeMode).$save().then ->
            $mdDialog.hide()
            $state.go("^.input")
  

  $scope.saveTempTranscription = (ev)->
    $scope.transcription.setTempChanged(false).$save().then ->
      toast = $mdToast.simple()
        .textContent('下書きを保存しました')
        .position('bottom right')
        .hideDelay(3000)
      console.log toast        
      $mdToast.show(toast)

  $scope.discardTemp = (ev)->
    confirm = $mdDialog.confirm()
      .title('作業内容の破棄')
      .textContent('作業内容を破棄して、翻刻文を以前の状態に戻します。よろしいですか？')
      .ariaLabel('Are you sure to disard the current text?')
      .targetEvent(ev)
      .ok('破棄')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      $scope.transcription.abortEditing().$save().then ->
        toast = $mdToast.simple()
          .textContent('変更を破棄しました')
          .position('bottom right')
          .hideDelay(3000)
        $mdToast.show(toast)

  $scope.completeTranscription = (ev) ->
    diffCount = $scope.transcription.countDiff()
    previousText = $scope.transcription.text
    text = $scope.transcription.tempText
    $mdDialog.show
      templateUrl: 'templates/transcription/confirm_dialog.html'
      parent: angular.element(document.body)
      targetEvent: ev,
      clickOutsideToClose: false
      controller: ($scope, $mdDialog) ->
        $scope.finished = (transcription.prevStatus is 'finished')
        $scope.shared = true
        $scope.requestReview = false
        $scope.transcription = transcription
        $scope.diffCount = diffCount
        $scope.comment = ""
        $scope.cancel = -> $mdDialog.hide()
        $scope.submit = ->
          $mdDialog.hide()          
          $scope.transcription.endEditing()
          if $scope.finished # 翻刻完了時
            $scope.transcription.setFinished()                        
          $scope.transcription.$save().then ->
            # 進捗更新
            book =Books.get($scope.transcription.getBookId())
            book.updateProgress()
            # 文字数更新
            Users.addCharCount(diffCount)
            # タイムライン投稿
            Timeline.$add
              event: 'transcription'
              bookId: $scope.transcription.getBookId()
              content: parseInt($scope.transcription.$id)
              comment: $scope.comment
              diffCount: diffCount
              shared: $scope.shared
              requestReview: $scope.requestReview
              code: $scope.transcription.getCode()
              previousText: previousText
              text: text
            $mdDialog.show
              templateUrl: 'templates/transcription/finishing_dialog.html'
              parent: angular.element(document.body)
              targetEvent: ev,
              clickOutsideToClose:true
              controller: ($scope, $mdDialog) ->
                $scope.transcription = transcription
                $scope.diffCount = diffCount
                $scope.close = -> $mdDialog.hide()

  $scope.freeze = ->
    if CurrentUser.get().isAdmin()
      $scope.transcription.freeze().$save()

  $scope.unfreeze = ->
    if CurrentUser.get().isAdmin()
      $scope.transcription.unfreeze().$save()

app.controller "TranscriptionContentStatusCtrl", ($scope, $state, transcription) ->
  $scope.transcription = transcription
  $scope.contentIndex = parseInt(transcription.$id)+1+""
  $scope.transcriptions = $scope.$parent.transcriptions
  $scope.changeIndex = () ->
    console.log "change"
    $state.go('transcription.content.view', content: parseInt($scope.contentIndex))
  

app.controller "TranscriptionContentCtrl", ($scope, $state, $mdDialog, $stateParams, transcription, $window) ->
  console.log "content"
  $scope.content = parseInt($stateParams.content)
  $scope.$parent.content =  $scope.content
  $scope.transcription = transcription
  $scope.transcription.$loaded ->
    $scope.$parent.transcription = $scope.transcription
    $scope.$parent.editedByCurrentUser =
      $scope.transcription.editedBy is $scope.$parent.auth.uid
  $scope.childState = $state.$current.name.split(".").reverse()[0]
  $scope.$parent.book.$loaded ->
    $scope.$parent.viewer.goToPage($scope.content-1)


     



// WEBPACK FOOTER //
// ./app/controllers/transcription_controllers.coffee